// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"OptionsMenu-module__tooltip--OI2wt"};